export default function MachineryControllerForm() {
  return (
    <div className="job-form-container">
      <h1>Apply – Machinery Controller</h1>
      <p>Machine deployment & monitoring</p>

      <div className="job-form-grid">
        <input placeholder="Full Name" />
        <input placeholder="Phone Number" />
        <input placeholder="Machines Handled" />
        <input placeholder="Field Operations Experience (Years)" />
        <textarea placeholder="Maintenance & Scheduling Experience" />
      </div>

      <button>Submit Application</button>
    </div>
  );
}
